export const Content = ({ children, className, style={}, ...props }) => {
    return (<div className={'content-area ' + className} style={style} {...props}>
        {children}
    </div>)
}